<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="ExpandLessFilled">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M13.7753 12.1086C13.5312 12.3527 13.1355 12.3527 12.8914 12.1086L9.99999 9.21724L7.1086 12.1086C6.86453 12.3527 6.4688 12.3527 6.22472 12.1086C5.98064 11.8646 5.98064 11.4688 6.22472 11.2247L9.55805 7.89141C9.80213 7.64733 10.1979 7.64733 10.4419 7.89141L13.7753 11.2247C14.0193 11.4688 14.0193 11.8646 13.7753 12.1086Z" fill="#3751FF"/>
</g>
</svg>
